<a href="#" style="display: none"></a>

<ng-container *ngIf="isLoaded">
    <app-alert level="info" *ngIf="rows.length == 0">{{'planSummary_plan_empty' | translate}}</app-alert>

    <app-table [columns]="columns" [rows]="rows" pageSize="20" sortBy="StudyYear" *ngIf="rows.length > 0">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{row.StudyYear}}</td>
                <td>
                    {{row.Name}} ({{row.Code}})
                    <div class="hidden-lg-up text-sub">
                        <div>
                            <label>{{'planSummary_plan_lblEcts' | translate}}:</label>
                            {{row.Ects}}
                        </div>

                        <div>
                            <label>{{'planSummary_plan_lblWeekCount' | translate}}:</label>
                            {{row.WeekCount}}
                        </div>
                    </div>
                </td>
                <td class="hidden-md-down">{{row.Ects}}</td>
                <td class="hidden-md-down">{{row.WeekCount}}</td>
            </tr>
        </ng-template>
    </app-table>
</ng-container>
